// BetModalComponent.js

import React, { useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";

const BetModal = ({ betData , type }) => {
  const [show, setShow] = useState(false);
  const [selectedData, setSelectedData] = useState([]);

  const handleShow = (data) => {
   const filteredData = data.filter(item => item.type === type);
     setSelectedData(filteredData);
    setShow(true);
  };

  // console.log("bet data is ", betData , type);
  // const evenetName = sessionStorage.getItem("eventname")
  const eventName = sessionStorage.getItem("eventname");
  const runner1 = sessionStorage.getItem("runner1"); 
  const runner2 = sessionStorage.getItem("runner2"); // e.g., "Warwickshire v Durham"
  // e.g., "Warwickshire v Durham"
   // e.g., "Warwickshire v Durham"

// Split by " v " (with spaces to avoid accidental splits like "navy" -> "na", "y")
//     const [team1, team2] = eventName.split(" v ");

// console.log("Team 1:", team1); // Warwickshire
// console.log("Team 2:", team2); // Durham


  const handleClose = () => setShow(false);

  return (
    <>
      {/* Button to trigger the modal */}
      <p
        className="btn btn-success rounded-pill text-black"
        style={{ marginBottom: "14px" }}
        onClick={() => handleShow(betData)}
      >
        <i className="bi bi-book"></i> View Bets
      </p>

      {/* Modal */}
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{eventName} ({type})</Modal.Title>  
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>USERNAME</th>
                <th>{runner1}</th>
                <th>{runner2}</th>
              </tr>
            </thead>
            <tbody>
  {selectedData?.map((item, index) => (
    <tr key={index}>
      <td>{item.phone}</td>
      <td style={{ color: item.runnerName === runner1 ? "green" : "red" }}>
        {item.runnerName === runner1 ? item.betAmount : "0.00"}
      </td>
      <td style={{ color: item.runnerName === runner2 ? "green" : "red" }}>
        {item.runnerName === runner2 ? item.betAmount : "0.00"}
      </td>
    </tr>
  ))}
</tbody>

          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BetModal;
